import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import CustomPagination from "../../components/pagination";
import ProvinceModal from "../../components/province-modal";
import ProvinceList from "../../components/province-list";
import { provinceService } from "../../utils/services/province.service";
import { countryService } from "../../utils/services/country.service";
import buildQuery from "../../utils/query-builder";

const initialState = {
  columns: [
    {
      name: "Name",
      key: "name",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      fetchApi: (searchKey, client_id, limit, skip) =>
        provinceService.fetchProvinceName(searchKey, client_id, limit, skip),
      loadMoreButton: true,
      searchKey: "",
    },
    {
      name: "Code",
      key: "code",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      fetchApi: (searchKey, client_id, limit, skip) =>
        provinceService.fetchProvinceCode(searchKey, client_id, limit, skip),
      loadMoreButton: true,
      searchKey: "",
    },
    {
      name: "Country",
      key: "country",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "name",
      fetchApi: (searchKey = "", client_id, limit, skip) =>
        countryService.fetch(searchKey, buildQuery({ limit, skip }), "name"),
      loadMoreButton: true,
      searchKey: "",
    },
  ],
  limit: 15,
  populate: ["country"],
};
function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x,
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col,
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };

    default:
      return state;
  }
}

export default function Province() {
  const [provinceData, setProvinceData] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [filterData, dispatch] = useReducer(filterReducer, initialState);
  const [page, setPage] = useState(0);
  const [dataCount, setDataCount] = useState(filterData.limit);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [viewMode, setViewMode] = useState("list");

  const fetchProvinceData = async () => {
    setLoading(true);
    try {
      const query = buildQuery(filterData, page);
      const response = await provinceService.fetch(searchValue, query);

      setProvinceData(response.data);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProvinceData();
  }, [page, searchValue, filterData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_zone.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "340px" }}
      />
    </div>
  );

  return (
    <DashboardContainer
      searchBarPlaceholder={"Search by Province Name"}
      onSearchData={(p) => {
        setSearchValue(p);
        setPage(0);
      }}
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"Province List"}
      onChangeFilter={handleFilterChange}
      hideFilterClient={true}
      title={"+ Province"}
      setViewMode={setViewMode}
      filterData={filterData}
      fields={filterData.columns}
      onClickRefresh={() => fetchProvinceData()}
    >
      <ProvinceModal
        selectedProvince={selectedProvince}
        handleClose={() => {
          setOpenModal(false);
          setSelectedProvince(null);
        }}
        open={openModal}
        onAddData={fetchProvinceData}
      />
      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}
      {provinceData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <NoDataImage />
        </div>
      ) : (
        <ProvinceList
          onDeleteData={() => fetchProvinceData()}
          onEditData={(e) => {
            setSelectedProvince(e);
            setOpenModal(true);
          }}
          data={provinceData}
          viewMode={viewMode}
          deleteTitle={"Delete Province"}
          selectedProvince={selectedProvince}
          setSelectedProvince={setSelectedProvince}
          currentPage={page}
          itemsPerPage={filterData.limit}
          onChangeFilter={handleFilterChange}
          filterData={filterData}
        />
      )}
      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={filterData.limit}
        page={page}
        setPage={setPage}
        setRowsPerPage={(e) =>
          dispatch({ type: "UPDATE_LIMIT", payload: e })
        }
        disableNext={dataCount <= (page + 1) * filterData.limit}
      />
    </DashboardContainer>
  );
}
